import { render, staticRenderFns } from "./PhoneLogin.vue?vue&type=template&id=670de630&scoped=true&"
import script from "./PhoneLogin.vue?vue&type=script&lang=js&"
export * from "./PhoneLogin.vue?vue&type=script&lang=js&"
import style0 from "./PhoneLogin.vue?vue&type=style&index=0&id=670de630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670de630",
  null
  
)

export default component.exports